import { configService } from "../index";
import { BaseRequests, BaseRequestsInterface } from "./BaseRequests";
import Gift from "@/models/gift";

export default {
  ...BaseRequests(
    () => configService.profileGifts,
    "gift",
    () => new Gift()
  )
} as BaseRequestsInterface;
